export default "__VITE_ASSET__D2JofFsZ__"